import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import i18n from '@i18next/i18n';
import { IAddonInfo } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/element-model-props.interface';
import { getProjectBullet } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/character-utils/bullet';
import { IParagraph, ITextRun } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';
import { ElementBaseAccessibilityContent } from './base';
import { IAccessibilityManagerContentHandler } from '@src/slide/application/service/accessibility-manager/core/accessibility-manager.interface';

const SLIDE_NUM = 'slidenum';

export class ShapeAccessibilityContent extends ElementBaseAccessibilityContent {
    private shapeModel: IShapeModel;
    public constructor(model: IShapeModel, a11yManager: IAccessibilityManagerContentHandler) {
        super(model, a11yManager);
        this.shapeModel = model;
    }

    public getAccessibilityContent(isSelected = false, content = ''): string {
        let details = '';
        if (this.shapeModel.paragraphList && this.shapeModel.paragraphList?.length > 0) {
            this.shapeModel.paragraphList.forEach((paragraph, index) => {
                details += this.getAllTextFromTextRuns(paragraph, index);
            });
        }
        if (isSelected) {
            if (this.shapeModel.isText) {
                details += i18n.t('文本框');
            } else {
                details += i18n.t('形状');
            }
        }
        return details;
    }

    /**
     * 获取shape中的全部文本并拼接
     */
    private getAllTextFromTextRuns(paragraph: IParagraph, index: number): string {
        let content = '';
        if (paragraph.textRuns && paragraph.textRuns.length > 0) {
            content += getProjectBullet(paragraph, this.shapeModel.paragraphList, index);
            content = `${content} ${paragraph.textRuns.reduce((res, curText) => {
                let { text } = curText;
                // 判断是否为链接
                if (curText.styles?.href) {
                    text = this.getHrefText(curText, this.shapeModel.props.addon);
                }
                if (curText.fieldType === SLIDE_NUM) {
                    text = i18n.t('幻灯片编号：') + text;
                }
                return res + text;
            }, '')}。`;
        }
        return content;
    }


    // 获取链接（包括普通链接和第三方内容）的具体内容
    private getHrefText(curText: ITextRun, addon: IAddonInfo | undefined) {
        let text = curText.text ? curText.text : curText.styles?.href;
        if (addon) {
            // 插入的第三方内容
            const title = this.a11yManager.services
                .addonManager?.getAddonFullScreenTitle(addon.iframeId, addon.extraData);
            text = `${i18n.t('第三方内容')}：${title}`;
        } else {
            // 插入的链接
            text = `${i18n.t('链接开头')}，${text}，${i18n.t('链接末尾')}`;
        }
        return text;
    }
}


